<isophi-info-popup *transloco="let t" [title]="t('diagnostics/popup/title')" [(dontShowAgain)]="dontShowAgain">
  <div class="text-wrapper">
    <div class="intro-section">
      <div class="intro-text">
        <div [innerHTML]="t('diagnostics/popup/intro1')"></div>
        <div [innerHTML]="t('diagnostics/popup/intro2')"></div>
      </div>

      <img class="intro-image" src="../../../../assets/img/foto/isophi-skolka-141.jpg" alt="" />
    </div>

    <div [innerHTML]="t('diagnostics/popup/textPedagog1')"></div>
    <div [innerHTML]="t('diagnostics/popup/textPedagog2')"></div>

    <ng-container *ngIf="isManager$ | async">
      <div [innerHTML]="t('diagnostics/popup/textPedagog4')"></div>
    </ng-container>

    <ng-container *ngIf="(isManager$ | async) === false">
      <div [innerHTML]="t('diagnostics/popup/text', { email: authService.loggedUser.email })"></div>
    </ng-container>

    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>

  <ng-container slot="actions">
    <button class="btn" [ngClass]="(isManager$ | async) ? 'btn-outline-dark' : 'btn-secondary'" (click)="close()">
      {{ t('diagnostics/popup/continue') }}
    </button>
    <button *ngIf="isManager$ | async" (click)="navigate()" class="btn btn-secondary">
      {{ t('diagnostics/popup/add') }}
    </button>
  </ng-container>
</isophi-info-popup>
